import React, { useState } from 'react';
import {
  Typography, Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  // Chip,
  Button,
  // Dialog,
  // DialogTitle,
  // DialogContent,
  // DialogContentText,
  // DialogActions,
  Snackbar,
  // Grid,
  // FormControl,
  // InputLabel,
  // Select,
  // MenuItem,
  // TextField,
  // InputAdornment,
  Avatar
} from '@mui/material';
import { useMain } from '../hooks/useMain';
import { useNavigate } from 'react-router';
import TableCells from 'src/components/Tables/TableCells';
// import { Search } from '@mui/icons-material';
// import { map } from 'lodash';

export const TrimData = (data) => {
  if (data?.length < 25)
    return data;
  return data?.substring(0, 15) + '...' + data?.substring(data?.length - 10);
};

const Users = ({ data, setData }) => {
  const [alert, setAlert] = useState('');
  const { deleteMembership } = useMain();

  // const handleDeleteField = async (id) => {
  //   // console.log('deleting....')
  //   const res = await deleteMembership(id);

  //   if (res?.statusCode === 200) {
  //     setData(data?.filter((data) => data?._id !== id));
  //     setAlert('Membership deleted successfully')
  //   }
  //   else {
  //     setAlert(res?.message)
  //   }
  // };

  const navigate = useNavigate();

  return (
    <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
      <Snackbar
        open={alert === '' ? false : true}
        autoHideDuration={6000}
        onClose={() => {
          setAlert('');
        }}
        severity="error"
        message={alert}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      />

      <Table
        aria-label="simple table"
        sx={{
          whiteSpace: "nowrap",
          mt: 2
        }}
      >
        <TableHead>
          <TableRow
            sx={{
              background: '#6174DD',
            }}
          >
            <TableCells
              borderRadius={'10px 0 0 10px'}
              color={'white'}
              type={'Heading'}
              data={'Name'}
            />
            {
              [
                'Email',
                'Address',
                'Branch',
                'kyc',
                'Subscription Status',
                'Payment Status',
                'Start Date',
              ].map((item, index) =>
                <TableCells
                  key={index}
                  color={'white'}
                  type={'Heading'}
                  data={item}
                />
              )
            }
            <TableCells
              borderRadius={'0px 10px 10px 0px'}
              color={'white'}
              type={'Heading'}
              data={'End Date'}
            />
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map((item) => (
            <TableRow
              key={item?._id}
              sx={{
                // background:'#FAFAFA'
              }}
            >
              <TableCells
                // color={'white'}
                // background={'red'}
                type={'content'}
                data={TrimData(item?.name)}
              />
              <TableCells
                borderRadius={'10px 0 0 10px'}
                // color={'white'}
                // background={'red'}
                type={'content'}
                data={TrimData(item?.email)}
              />
              <TableCell>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: 'column',
                    gap: '5px'
                  }}
                >
                  {
                    item?.salonAddress?.map((k, i) =>
                      <Box
                        key={i}
                        sx={{
                          background: '#D0D0D0',
                          padding: '10px',
                          borderRadius: '5px',
                          width: '150px',
                          whiteSpace: 'pre-wrap',
                          // overflowX: 'auto',
                          // '&::-webkit-scrollbar': {
                          //     width: '0px',
                          // }
                        }}
                      >
                        <Typography variant="subtitle2" fontWeight={600}>
                          {TrimData(k?.address)}, {k?.city}, ({k?.pincode})
                        </Typography>
                      </Box>
                    )
                  }
                </Box>
              </TableCell>

              <TableCell>
                <Button
                  // variant="outlined"
                  size="small"
                  onClick={() => navigate('/branches')}
                >
                  All Branches
                </Button>
              </TableCell>

              <TableCell>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: 'column',
                    gap: '5px'
                  }}
                >
                  {
                    item?.kyc?.map((k, i) =>
                      <Avatar
                        src={k?.documentImg}
                        alt={k?.documentName}
                        key={i}
                        sx={{
                          width: '90px',
                          height: '60px',
                          borderRadius: '10px'
                        }}
                      />
                    )
                  }
                </Box>
              </TableCell>
              <TableCells
                // color={'white'}
                // background={'red'}
                type={'content'}
                data={item?.subscriptionId?.status}
              />
              <TableCells
                // color={'white'}
                // background={'red'}
                type={'content'}
                data={item?.subscriptionId?.paymentStatus}
              />
              <TableCells
                // color={'white'}
                // background={'red'}
                type={'content'}
                data={new Date(item?.subscriptionId?.startDate)?.toDateString()}
              />
              <TableCells
                // color={'white'}
                // background={'red'}
                type={'content'}
                data={new Date(item?.subscriptionId?.endDate)?.toDateString()}
              />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default Users;
